import { lazy } from 'react';
import { Navigate, createBrowserRouter } from 'react-router';
import Loadable from '../layouts/full/shared/loadable/Loadable';
import RequireInternal from './RequireInternal';

const FullLayout = Loadable(lazy(() => import('../layouts/full/FullLayout')));
const BlankLayout = Loadable(lazy(() => import('../layouts/blank/BlankLayout')));

const BoardView = Loadable(lazy(() => import('../views/board')));
const WorkItems = Loadable(lazy(() => import('../views/work-items')));
const Tickets = Loadable(lazy(() => import('../views/tickets')));
const TicketDetail = Loadable(lazy(() => import('../views/tickets/detail')));
const Changelog = Loadable(lazy(() => import('../views/changelog')));
const Errors = Loadable(lazy(() => import('../views/errors')));
const Logs = Loadable(lazy(() => import('../views/logs')));
const KnowledgeBase = Loadable(lazy(() => import('../views/kb')));
const Tests = Loadable(lazy(() => import('../views/tests')));
// Lazy like every page, and more so than most: it carries the Perspective pivot
// engine, whose WebAssembly should download on this page and nowhere else.
const AiPerformance = Loadable(lazy(() => import('../views/ai-performance')));
const Login = Loadable(lazy(() => import('../views/auth/login')));
const ErrorPage = Loadable(lazy(() => import('../views/auth/error')));

const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <RequireInternal>
        <FullLayout />
      </RequireInternal>
    ),
    children: [
      { path: '/', element: <BoardView /> },
      { path: '/work-items', element: <WorkItems /> },
      { path: '/tickets', element: <Tickets /> },
      { path: '/tickets/:ticketId', element: <TicketDetail /> },
      { path: '/changelog', element: <Changelog /> },
      { path: '/errors', element: <Errors /> },
      { path: '/logs', element: <Logs /> },
      { path: '/knowledge-base', element: <KnowledgeBase /> },
      { path: '/tests', element: <Tests /> },
      { path: '/ai-performance', element: <AiPerformance /> },
      { path: '*', element: <Navigate to="/404" /> },
    ],
  },
  {
    path: '/',
    element: <BlankLayout />,
    children: [
      { path: '/login', element: <Login /> },
      { path: '/404', element: <ErrorPage /> },
    ],
  },
]);

export default router;
